import { useState } from "react";
import logo from "./assets/Screenshot 2026-07-10 212124.png";

function App() {
    const [pdfFile, setPdfFile] = useState(null);
    const [excelFile, setExcelFile] = useState(null);
    const [status, setStatus] = useState("");
    const [sending, setSending] = useState(false);

    const handleSubmit = async () => {

        if (!pdfFile || !excelFile) {
            alert("Please select both files.");
            return;
        }

        const formData = new FormData();
        formData.append("invoicePdf", pdfFile);
        formData.append("excelFile", excelFile);

        setSending(true);
        setStatus("Sending emails...");

        try {

            const response = await fetch(
                "https://invoice-api-137706340081.europe-west1.run.app/send-emails",
                {
                    method: "POST",
                    body: formData
                }
            );

            const result = await response.json();

            setStatus(result.message);

        } catch (err) {

            console.error(err);
            setStatus("An error occurred.");

        } finally {

            setSending(false);

        }
    };

    return (
        <div
            style={{
                minHeight: "100vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                background: "#eef2f7",
                fontFamily: "Arial, sans-serif"
            }}
        >
            <div
                style={{
                    width: 500,
                    background: "#fff",
                    borderRadius: 12,
                    padding: 40,
                    boxShadow: "0 8px 25px rgba(0,0,0,.15)"
                }}
            >
            <div style={{ textAlign: "center", marginBottom: 30 }}>
                <img
                    src={logo}
                    alt="Gainline"
                    style={{
                        width: 220,
                        height: "auto",
                        marginBottom: 15
                    }}
                />

                <h2
                    style={{
                        margin: 0,
                        color: "#333",
                        fontWeight: 500
                    }}
                >
                    Invoice Email Sender
                </h2>
            </div>
                <label><strong>Invoice PDF</strong></label>

                <label
                    style={{
                        display: "block",
                        border: "2px dashed #374834",
                        padding: 25,
                        marginTop: 10,
                        marginBottom: 20,
                        textAlign: "center",
                        cursor: "pointer",
                        borderRadius: 8,
                        background: "#fafcff"
                    }}
                >
                    {pdfFile
                        ? pdfFile.name
                        : "📄 Click to choose invoice PDF"}

                    <input
                        hidden
                        type="file"
                        accept=".pdf"
                        onChange={(e) => setPdfFile(e.target.files[0])}
                    />
                </label>

                <label><strong>Email Spreadsheet</strong></label>

                <label
                    style={{
                        display: "block",
                        border: "2px dashed #374834",
                        padding: 25,
                        marginTop: 10,
                        marginBottom: 30,
                        textAlign: "center",
                        cursor: "pointer",
                        borderRadius: 8,
                        background: "#fafcff"
                    }}
                >
                    {excelFile
                        ? excelFile.name
                        : "📊 Click to choose Excel file"}

                    <input
                        hidden
                        type="file"
                        accept=".xlsx"
                        onChange={(e) => setExcelFile(e.target.files[0])}
                    />
                </label>

                <button
                    onClick={handleSubmit}
                    disabled={sending}
                    style={{
                        width: "100%",
                        padding: 15,
                        fontSize: 16,
                        border: "none",
                        borderRadius: 8,
                        background: sending ? "#999" : "#374834",
                        color: "white",
                        cursor: sending ? "default" : "pointer"
                    }}
                >
                    {sending ? "⏳ Sending..." : "Send Emails"}
                </button>

                {status && (
                    <p
                        style={{
                            textAlign: "center",
                            marginTop: 20,
                            color: "#444"
                        }}
                    >
                        {status}
                    </p>
                )}
            </div>
        </div>
    );
}

export default App;